import { IComment } from '@/shared/IComment';
import { Button, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Spinner, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { ErrorMessage } from '../components/ErrorMessage';
import { useOperation } from '../components/useOperation';

export const DeleteCommentDialog = (props: {
  comment: any;
  onDelete: (comment: IComment) => Promise<any>;
  onClose: () => void;
}) => {

  const cancelRef = React.useRef<any>()

  const [execute, errorMessage, isProcessing] = useOperation(async () => {
    await props.onDelete(props.comment);
    props.onClose();
  }, [props.comment]);

  return (
    <AlertDialog
      isOpen
      leastDestructiveRef={cancelRef}
      onClose={props.onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            Are you sure you want to delete this comment?
          </AlertDialogHeader>

          <AlertDialogBody>
            <ErrorMessage error={errorMessage} />
            You may need to contact the EIT UM core team to restore it.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button colorScheme='red' onClick={execute} isDisabled={isProcessing} mr={3}>
              <HStack spacing={2}>{isProcessing && <Spinner />}<Text>Delete</Text></HStack>
            </Button>
            <Button ref={cancelRef} variant='outline' onClick={props.onClose}>
              Cancel
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}